if (!customElements.get('ts-cart-upsell')) {
  customElements.define('ts-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', (event) => {
        event.stopPropagation();
        if (event.target.name !== 'id') return;
        const option = event.target.selectedOptions[0];
        this.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const image = this.querySelector('img');
        if (image && option.dataset.image) {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
        }
      });
      this.addEventListener('submit', (event) => this.add(event));
    }

    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending) return;
      const form = event.target;
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      const drawer = this.closest('cart-drawer');
      const label = button.textContent;
      const body = new FormData(form);
      body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      body.set('sections_url', window.location.pathname);
      this.pending = true;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      error.hidden = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(form.action + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
          credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        if (!result.sections || drawer.getSectionsToRender().some(section => !result.sections[section.id])) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
        drawer.renderContents(result);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result });
        }
      } catch (failure) {
        error.textContent = failure instanceof TypeError ? this.dataset.error : failure.message;
        error.hidden = false;
      } finally {
        this.pending = false;
        button.disabled = false;
        button.textContent = label;
        form.removeAttribute('aria-busy');
      }
    }
  });
}
